/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.motions.rpc.PurchaseMotionsPublicEvaluationService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import * as References from './PurchaseMotionsPublicEvaluationService';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.motions.rpc.PurchaseMotionsPublicEvaluationService#evaluatePublic
 */
export const EVALUATE_PUBLIC_QUERY_FIELD_NAME = 'com_hubspot_purchase_motions_rpc_PurchaseMotionsPublicEvaluationService_evaluatePublic';
export const EVALUATE_PUBLIC_QUERY = /* #__PURE__ */registerQuery({
  fieldName: EVALUATE_PUBLIC_QUERY_FIELD_NAME,
  args: ['requestedCountryCode', 'productApiNames', 'locations', 'purchaseMotionFilterParameters'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.evaluatePublicRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});